// Native spellcheck policy for user-authored prose fields.
// Browser and OS spellcheck own suggestions and dictionaries. The extra hints
// ask supporting browsers to skip autofill, autocorrect, translation, and
// AI/proofing menu entries while keeping spelling suggestions and edit commands.
export const NATURAL_LANGUAGE_TEXT_INPUT_PROPS = Object.freeze({
  autoComplete: 'off',
  autoCorrect: 'off',
  spellCheck: true,
  translate: 'no',
  writingsuggestions: 'false',
});

const TEXT_CONTEXT_MENU_SELECTOR = [
  'textarea',
  'input',
  '[contenteditable]:not([contenteditable="false"])',
  '[role="textbox"]',
].join(',');

const TEXT_INPUT_CONTEXT_MENU_TYPES = new Set([
  '',
  'email',
  'number',
  'password',
  'search',
  'tel',
  'text',
  'url',
]);

function getElementFromTarget(target) {
  if (!target) return null;
  if (target.nodeType === 1 && typeof target.closest === 'function') return target;
  return target.parentElement || null;
}

export function isNativeTextContextMenuTarget(target) {
  const element = getElementFromTarget(target);
  const nativeTextTarget = element?.closest?.(TEXT_CONTEXT_MENU_SELECTOR);

  if (!nativeTextTarget) return false;

  if (nativeTextTarget.tagName?.toLowerCase() === 'input') {
    const inputType = (nativeTextTarget.getAttribute('type') || 'text').toLowerCase();
    return TEXT_INPUT_CONTEXT_MENU_TYPES.has(inputType);
  }

  return true;
}
